/**
 * 返回成绩查询或录取查询的界面相关信息
 * @param {*} flag 
 */
export function returnStudentSearchData(flag) {
    let data = {}
    switch (flag) {
        case 0:
        case "0":
            // 查询成绩
            data = {
                title: "成绩查询",
                status: "0", // 状态  代表显示的是输入框还是文本信息
                list: [
                    { title: "姓名", value: "", type: "input", key: "name" },
                    { title: "准考证/身份证", value: "", type: "input", key: "number" },
                ],
                showList: [
                    { title: "姓名", value: "", type: "text", key: "name" },
                    { title: "报考专业", value: "", type: "text", key: "readyProfession" },
                    { title: "准考证号", value: "", type: "text", key: "admissionNum" },
                    { title: "专业课科目一", value: "", type: "text", key: "theoryNum" },
                    { title: "专业课科目二", value: "", type: "text", key: "skillNum" },
                    { title: "备注", value: "", type: "text", key: "scoreRemark" },
                ],
                url: "/registration/getPersonalScore"
            }
            break;
        case 1:
        case "1":
            // 录取查询
            data = {
                title: "录取信息查询",
                status: "0", // 状态  代表显示的是输入框还是文本信息
                list: [
                    { title: "姓名", value: "", type: "input", key: "name" },
                    { title: "准考证/身份证", value: "", type: "input", key: "number" },
                ],
                showList: [
                    { title: "姓名", value: "", type: "text", key: "name" },
                    { title: "录取专业", value: "", type: "text", key: "readyProfession" },
                    { title: "准考证号", value: "", type: "text", key: "admissionNum" },
                    { title: "录取结果", value: "", type: "text", key: "isEnroll" },
                    { title: "备注", value: "", type: "text", key: "enrollRemark" },
                ],
                url: "/registration/getPersonalEnroll"
            }
            break;
        case 2:
        case "2":
            // 准考证打印
            data = {
                title: "准考证打印",
                status: "0", // 状态  代表显示的是输入框还是文本信息
                list: [
                    { title: "姓名", value: "", type: "input", key: "name" },
                    { title: "准考证/身份证", value: "", type: "input", key: "number" },
                ],
                showList: [
                    { title: "准考证", value: "", type: "file", key: "path" ,showText:""},
                ],
                url: "/admit/exportAdmitPdf"
            }
            break;

        default:
            break;
    }
    return data
}